module.exports = __webpack_public_path__ + "img/1e04c886a14fc3b400fbede0b0c42118.svg";